import { render } from "./apCheckbox2.vue?vue&type=template&id=432e6ab5&scoped=true&ts=true"
import script from "./apCheckbox2.vue?vue&type=script&lang=ts"
export * from "./apCheckbox2.vue?vue&type=script&lang=ts"

import "./apCheckbox2.vue?vue&type=style&index=0&id=432e6ab5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432e6ab5"]])

export default __exports__